import type { EaStatus, Group } from "../types";

/**
 * Applies the current group filter to a list of EAs.
 *
 * A selected group shows exactly its members. "All" (groupId === null) shows everything
 * except the members of groups flagged excluded_from_all - demo/test accounts that
 * shouldn't be mixed into the real portfolio's totals (see migration 0015). The server
 * applies the same rule to the /api/dashboard aggregates, so the stat cards and the lists
 * on screen always describe the same set of EAs.
 */
export function filterEasByGroup(
  eas: EaStatus[],
  groupId: number | null,
  groups: Group[],
): EaStatus[] {
  if (groupId !== null) return eas.filter((ea) => ea.group_id === groupId);

  const excluded = new Set(groups.filter((g) => g.excluded_from_all).map((g) => g.id));
  if (excluded.size === 0) return eas;
  return eas.filter((ea) => ea.group_id === null || !excluded.has(ea.group_id));
}
